import { Alert, AlertButton, Platform } from 'react-native';
import { alertEmitter } from '@/src/utils/alertEmitter';

export function showAlert(
  title: string,
  message?: string,
  buttons?: AlertButton[]
) {
  if (Platform.OS === 'web') {
    alertEmitter.enqueue({ title, message, buttons });
    return;
  }

  Alert.alert(title, message, buttons);
}
